import React, {Fragment} from 'react';
import autobind from 'autobind-decorator';

import {BaseTableColumn} from "../../Common/Tables/BaseTableColumn";
import {ConfirmationDialog} from "../../Common/ConfirmationDialog";
import {GenericModelViewer} from "../../Common/GenericModelViewer";
import {Permit} from "../../../Models/StreamBank/Permit";
import {service as PermitService} from "../../../Services/PermitService";

const model = new Permit;
export class PermitNameTableColumn extends BaseTableColumn {
    constructor() {
        super();

        this.state = {
            displayPermit: false,
            permit: {},
        }
    }

    @autobind
    showPermit(permitId) {
        PermitService.GetPermit(permitId)
            .then(({result}) => {
                this.setState({displayPermit: true, permit: result});
            })
    }

    @autobind
    getTitle() {
        const permitOrg = this.state.permit?.PermitType?.PermitOrganization?.shortName || this.state.permit?.PermitType?.PermitOrganization?.name;
        const permitType = this.state.permit?.PermitType?.shortName || this.state.permit?.PermitType?.name;

        return `${permitOrg} ${permitType} ${this.state.permit.permitNumber}`;
    }

    @autobind
    _render() {
        const dialogDescription = <span><span className="dialog-bold">This Information is Read-Only.</span> It must be edited from the Conservation Action Permits Page. Click on one of the links above to navigate there.</span>;

        return <Fragment>
            <ConfirmationDialog
                size="lg"
                Title={this.getTitle()}
                Body={
                    this.state.displayPermit &&
                    <GenericModelViewer
                        Model={model}
                        IsNewModel={false}
                        EditMode={false}
                        Data={this.state.permit}
                    />
                }
                CancelButtonMessage="Dismiss"
                OnClose={() => this.setState({displayPermit: false, permit: {}})}
                Display={this.state.displayPermit}
                DialogDescription={this.props.Editable ? null : dialogDescription}
            />
            <a className="sb-actionable-link" onClick={() => this.showPermit(this.props.rowData.permitId)}>
                {this.props.Value}
            </a>
        </Fragment>;
    }
}
